<template>
  <div>
    <div>
      <resource-nav-bar
        v-if="resource"
        :resource="resource"
        @open-about="handleAboutClick"
      />
    </div>
    <pane-intro :profile="profile" />
    <b-row style="margin-top: 35px">
      <b-col>
        <p>
          Write your message in the box below.
        </p>
      </b-col>
      <b-col>
        <p class="float-right">
          <toggle-single
            id="enable-agenda"
            label-name="Private"
            :toggle-model="isPrivate"
            btn-color="#0fb6fe"
            @toggle-click="handleToggleClick"
          />
        </p>
      </b-col>
    </b-row>
    <pane-entry
      :ref="paneEntryRefId"
      :generating="generating"
      @generate-click="handleGenerateClick"
    />
    <pane-response
      style="margin-top: 25px;"
      :curr-doc="currDoc"
      :path="path"
      :profile="profile"
      :max-words="maxFilteredWords"
      :idx="currIdx"
      :output="currOutput"
      :is-generating="generating"
      @page-to="handlePageTo"
    />
  </div>
</template>

<script>
import ToggleSingle from "@/components/common/toggleSingle";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import firebase from "firebase";
import PaneIntro from "./paneIntro";
import PaneEntry from "./paneEntry";
import PaneResponse from "./paneResponse";
import RecordViews from "@/mixins/RecordViews";
import { mapGetters } from "vuex";

export default {
  name: "Display_DearWords",
  mixins: [ResourceBlockDisplay, RecordViews],
  components: {
    ToggleSingle,
    ResourceNavBar,
    PaneIntro,
    PaneEntry,
    PaneResponse
  },
  created() {
    this.checkProfile();
  },
  mounted() {
    if (this.profile && this.myAppId) {
      this.setUpSnapShot();
    }
  },
  props: {
    isDemo: {
      type: Boolean,
      required: false,
      default: false
    },
    pathPublishing: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    filteredWords() {
      return this.theWords && Array.isArray(this.theWords)
        ? this.theWords.filter(theWord => {
            return (
              theWord.status &&
              theWord.status.state &&
              theWord.status.state == "COMPLETED" &&
              (
                  (!theWord.isPrivate ||
                theWord.isPrivate == false)
                  ||
                  (this.profile ?
                      theWord._created_by && theWord._created_by.uid ?
                          theWord._created_by.uid == this.userId : false :
                      theWord._created_by == this.sessionCookie)

              )
            );
          })
        : [];
    },
    filteredWordsOrdered() {
      let _words = this.filteredWords;
      return _words && Array.isArray(_words)
        ? _words.sort((a, b) => {
            if (
              a._created_at &&
              b._created_at &&
              a._created_at.seconds &&
              b._created_at.seconds
            ) {
              this.momentTest = a._created_at.seconds;
              return a._created_at.seconds - b._created_at.seconds;
            }
            return false;
          })
        : [];
    },
    maxFilteredWords() {
      return this.filteredWordsOrdered &&
        Array.isArray(this.filteredWordsOrdered) &&
        this.filteredWordsOrdered.length
        ? this.filteredWordsOrdered.length
        : 0;
    },
    userId() {
      return this.profile && this.profile.userId ? this.profile.userId : null;
    },
    firstname() {
      return this.profile && this.profile.firstname
        ? this.profile.firstname
        : null;
    },
    path() {
      if (!this.isDemo) {
        return this.userId && this.myAppId
          ? `/users/${this.userId}/lists/__apps/data/${this.myAppId}/ai_dearwords`
          : "";
      }
      return this.pathPublishing ? `${this.pathPublishing}/ai_dearwords` : "";
    },
    pathTextToAudio() {
      if (!this.isDemo) {
        return this.userId && this.myAppId
          ? `/users/${this.userId}/lists/__apps/data/${this.myAppId}/ai_dearwords_audios`
          : "";
      }
      return this.pathPublishing
        ? `${this.pathPublishing}/ai_dearwords_audios`
        : "";
    },
    currDoc() {
      return this.filteredWordsOrdered &&
        Array.isArray(this.filteredWordsOrdered) &&
        this.filteredWordsOrdered.length > this.currIdx
        ? this.filteredWordsOrdered[this.currIdx]
        : null;
    },
    currOutput() {
      return this.currDoc &&
        this.currDoc.outObj &&
        typeof this.currDoc.outObj == "object"
        ? this.currDoc.outObj
        : this.currDoc && this.currDoc.output
        ? this.convertOutputToJSON(this.currDoc.output)
        : null;
    }
  },
  methods: {
    checkProfile() {
      if (this.profile) return;
      this.$store.dispatch("user/getProfile");
    },
    setUpSnapShot() {
      if (this.path) {
        const db = firebase.firestore();
        this.collectionRef = db.collection(this.path);

        //    .where('_created_by','==', this.sessionCookie,"||","isPrivate","==",false);

        this.unsub = this.collectionRef.onSnapshot(snapshot => {
          this.theWords = [];
          snapshot.docs.forEach(doc => {
            this.theWords.push({ ...doc.data(), id: doc.id });
          });
          if (this.isEntry) {
            this.currIdx =
              this.filteredWordsOrdered &&
              Array.isArray(this.filteredWordsOrdered)
                ? this.filteredWordsOrdered.length - 1
                : 0;

            this.handleObjAndAudioCheck();
            this.isEntry = false;
          }
          //Check this that the current Payload

          if (this.currPayloadId) {
            //Handle teh processing of a submission
            let currentPayload = this.theWords.filter(aPayload => {
              return aPayload.genId == this.currPayloadId;
            });

            if (currentPayload && Array.isArray(currentPayload)) {
              let thisPayLoad = currentPayload[0];
              if (
                thisPayLoad &&
                thisPayLoad.status &&
                thisPayLoad.status.state
              ) {
                if (thisPayLoad.status.state == "PROCESSING") {
                  this.generating = true;
                } else if (thisPayLoad.status.state == "COMPLETED") {
                  if (thisPayLoad.output && thisPayLoad.id) {
                    if (
                      this.processOutput(thisPayLoad.output, thisPayLoad.id)
                    ) {
                      //Move to last position- using the filtered
                      this.currIdx =
                        this.filteredWordsOrdered &&
                        Array.isArray(this.filteredWordsOrdered)
                          ? this.filteredWordsOrdered.length - 1
                          : 0;
                    }
                  }

                  //clear textbox
                  let paneEntryComponent = this.$refs[this.paneEntryRefId];
                  if (paneEntryComponent.hasOwnProperty("resetForm")) {
                    paneEntryComponent.resetForm();
                  }
                  //stop loading
                  this.generating = false;
                  //Clear Id
                  this.currPayloadId = null;
                } else if (thisPayLoad.status.state == "ERRORED") {
                  this.generating = false;
                }
              }
            }
          }
        });
      }
    },
    handleGenerateClick(entryInput) {
      this.generateEntry(entryInput.replace(/(^"|"$)/g, ""));
    },
    generateEntry(entryInput) {
      let profileBy = this.profileBy();
      this.currPayloadId = `gen_${this.sessionCookie}_${Date.now()}`;

      let payload = {
        genId: this.currPayloadId,
        _created_at: new Date(),
        _created_by: profileBy,
        situation: entryInput,
        isPrivate: this.isPrivate
      };

      this.collectionRef.add(payload); // Include values for { unspecified parameter } fields

      this.generating = true;
    },
    processAudioFromOutput(outputObj, docId) {
      if (outputObj && docId) {
        let text = this.outputObjToText(outputObj);
        const db = firebase.firestore();
        let collectionRefTextToAudio = db.collection(this.pathTextToAudio);
        let profileBy = this.profileBy();

        let payload = {
          docId: docId,
          _created_at: new Date(),
          _created_by: profileBy,
          text: text,
          languageCode: "en-US", // Optional if per-document overrides are enabled
          ssmlGender: "MALE", // Optional if per-document overrides are enabled
          audioEncoding: "MP3", // Optional if per-document overrides are enabled
          voiceName: "en-US-Polyglot-1" // Optional if per-document overrides are enabled
        };

        collectionRefTextToAudio.add(payload); // Include values for { unspecified parameter } fields
      }
    },
    outputObjToText(outputObj) {
      let text = "";
      text += outputObj.encouraging_words
        ? `${outputObj.encouraging_words}`
        : "";
      text += outputObj.parting_words
          ? `${this.scriptureArrToText(outputObj.scriptures)}`
          : "";
      text += outputObj.parting_words
        ? `${outputObj.parting_words}`
        : "";
      text += outputObj.action_items
          ? `${this.actionsArrToText(outputObj.action_items)}`
          : "";
      return text;
    },
    scriptureArrToText(scriptureArr) {
      let scriptureTxt ="";
      const pause=",,,";
      if(Array.isArray(scriptureArr)) {
        scriptureArr.forEach((aScripture)=>{
          scriptureTxt += `${aScripture.text} ${this.bookChapterVerseFix(aScripture)}`;
          scriptureTxt += pause;
        });
      }
      return scriptureTxt;
    },
    actionsArrToText(actionsArr) {
      let actionsTxt ="";
      const pause=",,,";
      if(Array.isArray(actionsArr)) {
        actionsTxt += "Your Action Items ";
        actionsArr.forEach((anActionItem)=>{
          actionsTxt += `${this.processItem(anActionItem)}`;
          actionsTxt += pause;
        });
      }
      return actionsTxt;
    },
    /**TODO--Mixin**/
    processItem(item){
      if (typeof item === "string") return this.stripMarkupsAndHTML(item);
      if (typeof item === "object") return this.processObject(item);
    },
    processObject(itemObj){
      //Count the Keys
      if (Object.keys(itemObj).length == 1) {
        if (itemObj && itemObj.text) return itemObj.text;
        if (itemObj && itemObj.action) return itemObj.action;
      }
      if (Object.keys(itemObj).length == 2) {
        if (itemObj && itemObj.action && itemObj.reason) return `${itemObj.action} So that: ${itemObj.reason}`;
      }
    },
    stripMarkupsAndHTML(itemText){
      let itemTextStr = itemText;
      var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";

      for (var i = 0; i < specialChars.length; i++) {
        itemTextStr = itemTextStr.replace(new RegExp("\\" + specialChars[i], "gi"), "");
      }
      return itemTextStr;
    },
    bookChapterVerseFix(aScripture){
      if(aScripture.book_chapter_vers) return aScripture.book_chapter_vers;
      if(aScripture.book_chapter_verse) return aScripture.book_chapter_verse;
      return "The Bible";
    },
    handleResetForm() {
      this.input = "";
    },
    profileBy() {
      if (this.profile) {
        return {
          uid: this.profile.userId,
          name: `${this.profile.firstname} ${this.profile.lastname}`,
          imgURL: this.profile.imgURL
        };
      }
      //Sessions
      return this.sessionCookie;
    },
    processOutput(docOutput, docId = 0) {
      if (docOutput) {
        let output = this.convertOutputToJSON(docOutput);

        if (typeof output == "object") {
          //Get Audio and add it
          this.saveGeneratedResponseObject(output, docId);

          this.processAudioFromOutput(output, docId);
        }
        return true;
      }
      return false;
    },
    convertOutputToJSON(responseOutput, deep = 0) {
      let output = {};
      if (responseOutput) {
        try {
          output = responseOutput.replace(/(\r\n|\n|\r)/gm, "");
          output = JSON.parse(output);
        } catch (e) {
          console.error(e); // error in the above string (in this case, yes)!
          //check if quotes is the issue try again
          if (deep == 0) {
            deep++;
            //const regex = /((?:\s*?{\s*?|\s*?,\s*?)[^:]+)(?=:)/g;
            //const newRespOutput = responseOutput.replace(regex, '"$1"');
            const newRespOutput = responseOutput.replace(
              /(\s*?{\s*?|\s*?,\s*?)(['"])?([a-zA-Z0-9]+)(['"])?:/g,
              '$1"$3":'
            );
            output = this.convertOutputToJSON(newRespOutput, deep);
          }
        }
      }
      return output;
    },
    saveGeneratedResponseObject(genObj, docId) {
      let createdBy = this.profileBy();
      this.$store
        .dispatch("ai/addOutputObjForPathAndDocId", {
          path: this.path,
          docId: docId,
          outputObj: genObj,
          updatedBy: createdBy
        })
        .then(() => {})
        .catch(err => {});
    },
    handlePageTo(pageNumber) {
      this.currIdx = pageNumber;
      this.handleObjAndAudioCheck();
    },
    handleObjAndAudioCheck() {
      //CleanUp
      if (this.currDoc && this.currDoc.output) {
        //create object if exists- also creates audio
        //Check for object Doc
        if (!this.currDoc.outObj) {
          this.processOutput(this.currDoc.output, this.currDoc.id);
        }
        //Check for audio on Object
        if ((this.currDoc.outObj && !this.currDoc.outObj.audioPath) || this.forceAudioGeneration) {
          //Get Audio and Save Audio
          this.$store
            .dispatch("ai/getAudioForPathAndDocId", {
              path: `${this.path}_audios`,
              docId: this.currDoc.id
            })
            .then(audioDocData => {
              if (audioDocData && audioDocData.audioPath) {
                //Add Audio to Object
                this.currDoc.outObj.audioPath = audioDocData.audioPath;
                this.currDoc.outObj = { ...this.currDoc.outObj };
                //save path
              } else {
                //process audio
                this.processAudioFromOutput(
                  this.currDoc.outObj,
                  this.currDoc.id
                );
              }
            })
            .catch(err => {});
        }
      }
    },
    handleToggleClick() {
      this.isPrivate = !this.isPrivate;
    }
  },
  watch: {
    path(newValue, oldValue) {
      //temp- may take out
      if (newValue) {
        this.setUpSnapShot();
      }
    }
  },
  data() {
    return {
      sessionCookie: this.checkSession("myapp_deargod"),
      isPrivate: false,
      isEntry: true,
      currIdx: 0,
      currPayloadId: null,
      exportModalId: "export-modal-id",
      selectedExportTypeId: null, //email|pdf|printer
      input: "",
      myAppId:
        this.resource && this.resource.toolId ? this.resource.toolId : null,
      collectionRef: null,
      theWords: [],
      generating: false,
      paneEntryRefId: "pane-entry",
      forceAudioGeneration: true
    };
  }
};
</script>

<style lang="scss" scoped></style>
